import React from 'react';
import {Checkbox, Icon, Popup} from 'semantic-ui-react';

export const TransactionSection = ({trans, sectionHead, onTransactionSelect, handleReceiptClick}) => {
    return (
        <tr key={trans.id} style={{backgroundColor: 'rgba(238, 241, 243, 1)'}} >
            <td style={{padding: 20}}><Checkbox onChange={() => onTransactionSelect(trans.id, trans.selected, sectionHead)} checked={trans.selected} value={trans.id}/></td>
            <td style={{padding: 20}}>
                {trans.date}
                <Popup content={trans.receiptStatus === 'flaggedHR' ? 
                                'Flagged' : 
                                    trans.receiptStatus === 'requestedHR' ? 
                                    'Receipt Requested' : 
                                        trans.receiptStatus === 'uploadedEmployee' ? 
                                        'Receipt(s) Uploaded': 
                                            trans.receiptStatus === 'notUpdated' ?
                                            'Receipts pending' : 'Approved'} trigger={
                    <Icon size={'small'} style={{paddingLeft: 10, opacity: 0.6}} name="circle thin" 
                            color={trans.receiptStatus === 'flaggedHR' ? 
                                'red' : 
                                    trans.receiptStatus === 'requestedHR' ? 
                                    'yellow' : 
                                        trans.receiptStatus === 'uploadedEmployee' ? 
                                        'blue': 
                                            trans.receiptStatus === 'notUpdated' ?
                                            'purple' : 'green'} />
                } />
            </td>
            <td colSpan="1" style={{padding: 20}}>
                {trans.merchant.length > 40 ? trans.merchant.slice(0,38) + "..." : trans.merchant}
            </td>
            <td style={{padding: 20}}>
                {trans.category}
            </td>
            <td style={{padding: 20}}>
                $ {(trans.amount/100).toFixed(2)}
            </td>
            <td style={{paddingRight: 5}}>
                <Popup content='View Receipts' trigger={
                    <Icon name = 'file alternate outline' size='big'
                        disabled = {!trans.receipts.length || trans.receiptStatus === "notUpdated"}
                        onClick= {e => {
                            handleReceiptClick(trans)
                        }}
                    />
                }/>
            </td>
        </tr>
    );
};